import { WatermarkPosition } from './WatermarkPosition';

export const WatermarkPositionInEmailImages = {
  ...WatermarkPosition,
  GroundEdges: undefined, // GroundEdges not viable for email images.
};
